module.exports = __webpack_public_path__ + "img/img_intro_2_deco2_mb.4278928e.png";